import { createFileRoute } from '@tanstack/react-router';
import Settings from '@/pages/Settings';

type SettingsSearch = {
  tab?: 'general' | 'profile' | 'voice' | 'organisation' | 'billing' | 'integrations';
};

export const Route = createFileRoute('/settings')({
  component: Settings,
  validateSearch: (search: Record<string, unknown>): SettingsSearch => {
    const t = search.tab;
    return {
      tab:
        t === 'voice'
          ? 'voice'
          : t === 'organisation'
            ? 'organisation'
            : t === 'profile'
              ? 'profile'
              : t === 'billing'
                ? 'billing'
                : t === 'integrations'
                  ? 'integrations'
                  : 'general',
    };
  },
});
